import styled from 'styled-components';
import { TextField } from '@mui/material';

/* ============================================================
   Estilos de listagem compartilhados — themados via CSS vars.
   Usados por todas as páginas de tabela para padronizar o
   visual e o modo escuro.
   ============================================================ */

export const Container = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  background: transparent;
`;

export const Title = styled.h1`
  color: var(--text);
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 4px 0 22px;
  align-self: center;
`;

export const TableContainer = styled.div`
  width: 92%;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  border-radius: 18px;
  padding: 22px;
  overflow-x: auto;
  color: var(--text);
`;

export const Pagination = styled.div`
  margin-top: 22px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;

  button {
    min-width: 40px;
    padding: 9px 14px;
    border: 1px solid var(--border);
    border-radius: 10px;
    cursor: pointer;
    background: var(--surface-2);
    color: var(--text);
    font-size: 14px;
    font-weight: 600;
    transition: all 0.18s ease;

    &:hover:not(:disabled):not(.active) {
      border-color: var(--accent);
      color: var(--accent);
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }

    &.active {
      background: var(--gradient-brand-soft);
      color: #fff;
      border-color: transparent;
      box-shadow: var(--glow);
    }
  }
`;

export const ActionButton = styled.button`
  margin-left: 15px;
  border: none;
  background: none;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.18s ease, transform 0.15s ease;

  &:hover {
    color: var(--accent);
    transform: scale(1.12);
  }

  &:first-child {
    margin-left: 0;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  color: var(--text);

  th,
  td {
    padding: 12px 10px;
    border-bottom: 1px solid var(--border);
    text-align: center;

    button {
      border: none;
      background: none;
      cursor: pointer;
      color: var(--text-muted);
      transition: color 0.18s ease;
    }
    button:hover {
      color: var(--accent);
    }
  }

  th {
    background: var(--surface-2);
    color: var(--text-muted);
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    position: sticky;
    top: 0;
  }

  th:first-child {
    border-top-left-radius: 12px;
  }
  th:last-child {
    border-top-right-radius: 12px;
  }

  tbody tr {
    transition: background 0.15s ease;
  }

  tbody tr:nth-child(even) {
    background: rgba(127, 127, 127, 0.045);
  }

  tbody tr:hover {
    background: rgba(43, 123, 255, 0.1);
  }
`;

export const ActionsCell = styled.td`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .container {
    transform: scale(0.8);
  }
`;

export const SearchCard = styled.div`
  width: 92%;
  margin-bottom: 14px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
`;

export const TextFeldClientSearch = styled(TextField)`
  width: 40%;
  min-width: 220px;
`;
